module.exports = __webpack_public_path__ + "img/help-your-children.3ae8b8a.jpg";